import { Text, Link, Box } from '@primerai/thread';
import { TERMS_URL } from '~/constants';

const TermsAcknowledgement = () => (
  <Box my="$5">
    <Text>
      By proceeding, you agree to our{' '}
      <Link href={TERMS_URL} isExternal>
        Enterprise Terms and Conditions
      </Link>
    </Text>
  </Box>
);

export default TermsAcknowledgement;
